import React, { FC, useMemo, useState } from 'react';
import './WorkoutDurationStep.scss';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';

interface WorkoutDurationStepProps {
  onNext?: () => void;
  value?: string;
  onChange?: (val: string) => void;
}

// How long should the workouts be?
// How long should be the workouts?
export const WorkoutDurationStep: FC<WorkoutDurationStepProps> = ({ onNext, value, onChange }) => {
  const [localDuration, setLocalDuration] = useState<string>('');
  const selectedDuration = value !== undefined ? value : localDuration;

  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();
  const workoutDuration = programMasterData?.workoutDuration;
  const options = workoutDuration?.options;

  const durationOptions = useMemo(() => {
    if (!options) return [];
    return [...options].sort((a, b) => (a.order || 0) - (b.order || 0));
  }, [options]);

  if (isLoading) {
    return <div className="workout-duration-step">{'Loading options...'}</div>;
  }

  if (isError || !workoutDuration) {
    return <div className="workout-duration-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="workout-duration-step">
      <h2 className="step-title">{workoutDuration.title}</h2>
      {workoutDuration.subtitle && <p className="step-subtitle">{workoutDuration.subtitle}</p>}

      <div className="duration-buttons">
        {durationOptions.map((duration) => (
          <button
            key={duration.id}
            className={`duration-btn ${selectedDuration === duration.slug ? 'selected' : ''}`}
            onClick={() => {
              if (onChange) onChange(duration.slug);
              setLocalDuration(duration.slug);
              if (onNext) onNext();
            }}
          >
            {duration.title}
          </button>
        ))}
      </div>
    </div>
  );
};
